// extracted by mini-css-extract-plugin
export default {"ForumGhostButton":"dY_YHoOCjqCdc9iUTISg"};